import React from "react";
import "./OverView.css";
import "./Features.css";
import { Link } from "react-scroll";
import dashboard from "../AssetProduct/dashboard.png";
import assetdashboard from "../AssetProduct/assetDashboard.png";
import inspDashboard from "../AssetProduct/inspDashboard.png";
import serviceDashboard from "../AssetProduct/serviceDashboard.png"
import { BsArrowRight } from "react-icons/bs";

const features = [
  // {
  //   id: "Asset-Remote-Monitoring",
  //   title: "Asset Remote Monitoring",
  //   text: "Remote asset monitoring tracks and manages assets from a distance, often using Internet of Things (IoT) technology and software. It lets organizations monitor equipment, vehicles and other valuable items in real time, wherever they are, to improve efficiency, reduce costs and enhance security.",
  //   image: assetdashboard,
  // },
   {
    id: "Asset-Management",
    title: "Enterprise Asset Management (EAM)",
    text: "Asset tagging and visibility, geo tagging, floor mapping, QR codes, asset register, asset transactions, asset accounting, asset tracking and more.",
    image: assetdashboard,
  },
    {
    id: "Inventory-Management",
    title: "Inventory Management",
    text: "Inventory purchase, goods receipt, inventory issue, inventory tracking and more.",
    image: assetdashboard,
  },
  {
    id: "Contract-Management",
    title: "Contract Management",
    text: "Contract creation, scheduling, support, accounting, contract tracking and more.",
    image: assetdashboard,
  },
 
  {
    id: "Inspection-Management",
    title: "Inspection Management",
    text: "Inspection scheduling, inspection checklist preparation, conducting inspections, tracking and more.",
    image: inspDashboard,
  },
 {
    id: "Service-Management",
    title: "Service Management",
    text: "Service contract creation, scheduling, support, accounting, service contract tracking and more.",
    image: serviceDashboard,
  },
   {
    id: "Work-Management",
    title: "Work Order-Management",
    text: "Work contract creation, scheduling, support, accounting, work contract tracking and more.",
    image: assetdashboard,
  },
  {
    id: "Mobile-EAM",
    title: "Mobile EAM",
    text: "Manage and maintain your EAM on a mobile application.",
    image: assetdashboard,
  },
  // {
  //   id: "Predictive-Maintenance",
  //   title: "Predictive Maintenance",
  //   text: "Predictive maintenance uses data analysis and machine learning to predict when high-value assets are likely to fail, so you can maintain them before a breakdown occurs. It optimizes asset performance, extends asset lifecycles and reduces downtime and costs.",
  //   image: assetdashboard,
  // },
 
 
];

const Features = () => {
  return (
    <section
className="WhyAM mx-auto w-full max-w-[110rem] px-6 sm:px-10 font-['Poppins',sans-serif]"      id="Features"
    >
      {/* <div className="inline-block rounded-full bg-[#002C78]/10 px-4 py-1 text-xs font-semibold uppercase tracking-wider text-[#002C78] mb-4">
        Features & Capabilities
      </div> */}
      <h2 className="mb-4 text-3xl sm:text-4xl lg:text-[2.6rem] font-bold leading-tight text-[#002C78]">
        Key Features
      </h2>
      <div className="w-24 h-1 bg-[#002C78] mb-8 sm:mb-10"></div>

      <div className="flex flex-col gap-8 lg:flex-row lg:gap-14">
        <nav
          aria-label="Features"
          className="lg:w-[22rem] lg:shrink-0"
        >
          <ul className="am-feat-nav m-0 list-none p-0">
            {features.map((f) => (
              <li key={f.id}>
                <Link
                  className="am-feat-link"
                  activeClass="am-feat-link--active"
                  to={f.id}
                  spy={true}
                  smooth={true}
                  offset={0}
                  duration={500}
                  containerId="content-container"
                >
                  {f.title}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div
          id="content-container"
          className="am-feat-scroll h-[70vh] min-w-0 flex-1 overflow-y-auto pr-2 sm:pr-4"
        >
          <Content />
        </div>
      </div>
    </section>
  );
};

export const Content = () => {
  return (
    <div className="flex flex-col">
      {features.map((f, i) => (
        <article
          key={f.id}
          id={f.id}
         className={`grid items-center gap-8 py-8 xl:grid-cols-2 xl:gap-14 ${i === 0 ? "pt-0" : "border-t border-gray-200"}`}
        >
          <div className="flex flex-col gap-5">
            <h3 className="text-2xl font-bold leading-snug text-[#002C78]">
              {f.title}
            </h3>
            <p className="max-w-[60ch] text-[1.05rem] leading-[1.8] text-[#4b5563]">
              {f.text}
            </p>
            <button
              type="button"
              className="inline-flex items-center gap-2 font-semibold text-[#F23100] hover:text-[#d12a00] transition-colors w-fit bg-transparent p-0"
            >
              {/* Explore more <BsArrowRight aria-hidden="true" /> */}
            </button>
          </div>
          <img
            src={f.image}
            alt={`${f.title} screen in iAssetMax™`}
            loading="lazy"
            className="w-full rounded-xl border border-gray-200 shadow-[0_10px_28px_rgba(0,44,120,0.08)] transition-transform duration-300 hover:scale-[1.02]"
          />
        </article>
      ))}
    </div>
  );
};

export default Features;
